<template>
	<div>
		<v-container>
			<v-form ref="formActual">
				<template v-for="c in categorias">
					<v-row :key="c.ID">
						<v-col class="v-title">
							{{ c.Etiqueta }}
						</v-col>
					</v-row>
					<v-row
						v-for="data in valor[c.Propiedad]"
						:key="data.Nombre + c.ID"
					>
						<v-col cols="3">
							{{ data.Nombre }}
						</v-col>
						<v-col cols="2">
							{{ data.Referencia }}
						</v-col>
						<v-col cols="4">
							<v-text-field
								type="number"
								hide-details="auto"
								class="campo-formulario"
								v-model="data.Valor"
							></v-text-field>
						</v-col>
						<div
							v-if="
								(data.LimiteInferior || data.LimiteSuperior) &&
									!!data.Valor
							"
						>
							<v-col cols="1" v-if="mostrarAdvertencia(data)">
								<v-icon color="red">close</v-icon>
							</v-col>
							<v-col cols="1" v-else>
								<v-icon color="green">checkmark</v-icon>
							</v-col>
						</div>
					</v-row>
				</template>

				<v-row>
					<v-col cols="1"><v-spacer></v-spacer></v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Otros
					</v-col>
					<v-col cols="6">
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.otros"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Estudios de gabinete (ultrasonidos, TAC, Rx, etc.)
					</v-col>
					<v-col cols="6">
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.estudiosGabinete"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6">
						Observaciones
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="1"><v-spacer></v-spacer></v-col>
					<v-col cols="8">
						<v-textarea
							outlined
							v-model="valor.observaciones"
						></v-textarea>
					</v-col>
				</v-row>
			</v-form>
		</v-container>

		<v-layout row class="mt-3">
			<v-flex xs6>
				<v-btn color="primary" @click.prevent="siguiente">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" @click.prevent="guardar">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
import ServicioCatalogos from "../../../services/catalogos";
export default {
	props: ["datos"],
	name: "evaluacionBioquimica",
	data() {
		return {
			categorias: [
				{
					ID: 1,
					Etiqueta: "Función Renal",
					Propiedad: "FuncionRenal"
				},
				{
					ID: 2,
					Etiqueta: "Química Sanguínea",
					Propiedad: "QuimicaSanguinea"
				},
				{
					ID: 3,
					Etiqueta: "Biometría Hemática",
					Propiedad: "BiometriaHematica"
				},
				{
					Etiqueta: "Examen General de Orina",
					Propiedad: "ExamenGeneralOrina"
				}
			],
			valor: {
				Otros: "",
				EstudiosGabinete: "",
				Observaciones: ""
			}
		};
	},
	mounted() {
		this.valor = {
			...this.valor,
			...ServicioCatalogos.catalogos.ResultadosBioquimicos
		};
	},

	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	methods: {
		siguiente() {
			this.$emit("siguiente");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarEvaluacionBioquimica(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		mostrarAdvertencia(data) {
			if (data.LimiteInferior && data.Valor < data.LimiteInferior) {
				return true;
			}
			if (data.LimiteSuperior && data.Valor > data.LimiteSuperior) {
				return true;
			}
			return false;
		}
	},
	watch: {
		datos() {
			if (this.datos) {
				this.valor = JSON.parse(this.datos);
			}
		}
	}
};
</script>
<style>
.title {
	color: #1c62ad;
	font-size: 24px;
	font-weight: 400;
}
</style>
